import { useRef, useState, useEffect } from "react";
import Header from "../../commonComponents/header/Header";
import reloadImg from "../../../assets/images/reload.svg";
import arrowImg from "../../../assets/images/arrow-white-icon.svg";
import { useNavigate } from "react-router-dom";
import { useNetworkResilientVideo } from "../../../hooks/useNetworkResilientVideo";
const Information = () => {
  const navigate = useNavigate();
  const videoRef = useRef(null);
  useNetworkResilientVideo(videoRef); 

  const [isIntroStage, setIsIntroStage] = useState(true);
  const [isReplayFullscreen, setIsReplayFullscreen] = useState(false);
  const [isFirstWatch, setIsFirstWatch] = useState(true);
  const [showTopMode, setShowTopMode] = useState(false);

  useEffect(() => {
    if (isIntroStage && !isReplayFullscreen) {
      const t = setTimeout(() => setShowTopMode(true), 2000);
      return () => clearTimeout(t);
    }
  }, [isIntroStage, isReplayFullscreen]);

  const handleIntroEnd = () => {
    setIsFirstWatch(false);
    setIsIntroStage(false);
    setIsReplayFullscreen(false);
  };

  const playAgain = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
      videoRef.current.play();
    }
  };

  const goFullscreenReplay = () => {
    setIsIntroStage(true);
    setIsReplayFullscreen(true);
    setTimeout(() => {
      videoRef.current?.play();
    }, 50);
  };

  const handleProceed = () => {
    navigate("/needleeye-taking-pictures");
  };

  return (
    <div className="w-screen h-screen relative overflow-hidden">
      {/* ================= FULLSCREEN VIDEO ================= */}
      {/* ================= FULLSCREEN VIDEO ================= */}
      {isIntroStage && (
        <>
          <video
            ref={videoRef}
            className="w-full h-full object-contain bg-black"
            autoPlay
            disablePictureInPicture
            controls
            onEnded={handleIntroEnd}
          >
            <source src="https://t1developmentneedles.blob.core.windows.net/intro-videos/Moonshots_Proctoring.mp4?sp=r&st=2026-07-14T09:55:10Z&se=2031-03-13T18:10:10Z&sv=2026-02-06&sr=b&sig=9nRryYaYyKAIw7j96PYXA7G9CxeCGbkaKpWAVxAuGs8%3D" type="video/mp4" />
          </video>

          {/* Block seek first watch */}
          {isFirstWatch && (
            <div className="absolute bottom-0 left-0 w-full h-[50px] z-10" />
          )}

          {/* Instruction overlay */}
          {!isReplayFullscreen && (
            <div
              className={`
          absolute left-1/2 -translate-x-1/2
          px-8 py-2 rounded-2xl
       bg-[#111729]/95 backdrop-blur-md text-center
          transition-all duration-700
          ${
            showTopMode
              ? "top-1 max-w-[720px]"
              : "top-1/2 -translate-y-1/2 max-w-[720px]"
          }
        `}
            >
              {!showTopMode && (
                <p className="text-white app-video-overlay font-medium mb-2">
                  Please attentively watch this video…
                </p>
              )}
              <p className="text-white/90 app-body">
                You will be able to proceed once the video has ended.
              </p>
            </div>
          )}

          {/* Replay buttons */}
          {isReplayFullscreen && (
            <div className="absolute bottom-8 right-8 flex gap-3 z-20">
              <button
                onClick={playAgain}
                className="btn-size flex bg-btnBgColor items-center px-6 py-1.5 text-white text-[16px]"
              >
                <img src={reloadImg} alt="reload" className="mr-2 w-4" />
                Play Again
              </button>

              <button
                onClick={handleProceed}
                className="btn-size flex items-center px-6 py-1.5 bg-btnBgColor text-white text-[16px]"
              >
                Proceed
                <img src={arrowImg} alt="arrow" className="ml-2" />
              </button>
            </div>
          )}
        </>
      )}

      {/* ================= CONTENT SCREEN ================= */}
      {!isIntroStage && (
        <div className="flex flex-col min-h-screen bg-white overflow-x-hidden px-4 pt-4">
          <Header />

          <div className="flex-1 flex flex-col md:flex-row items-center justify-center px-1 pt-5 max-w-9xl mx-auto">
            {/* Video */}
            <div className="w-full md:w-1/2 flex justify-center items-center px-4 md:px-6 lg:px-8">
              <video
                ref={videoRef}
                className="w-full max-w-[520px] h-auto rounded-md shadow-md cursor-pointer"
                controls
                disablePictureInPicture
                onPlay={goFullscreenReplay}
              >
                <source
                  src="https://t1developmentneedles.blob.core.windows.net/intro-videos/Moonshots_Proctoring.mp4?sp=r&st=2026-07-14T09:55:10Z&se=2031-03-13T18:10:10Z&sv=2026-02-06&sr=b&sig=9nRryYaYyKAIw7j96PYXA7G9CxeCGbkaKpWAVxAuGs8%3D"
                  type="video/mp4"
                />
              </video>
            </div>

            {/* Divider */}
            <div className="hidden md:block self-stretch w-[1px] bg-dividerColor mx-4 my-[5%]" />

            {/* Text */}
            <div className="w-full md:w-1/2 flex flex-col justify-center px-4 sm:px-6 md:px-8 lg:px-10 mt-6 md:mt-0">
              <div className="max-w-[720px]">
                <h2
                  className="font-semibold mb-4 leading-snug outer-font-color
                  app-title"
                >
                  A video on using NeedleEye during assessment
                </h2>

                <p
                  className="mb-4 leading-relaxed outer-font-color
                  app-body"
                >
                  The NeedleEye app on your device is now synced with your
                  assessment.
                </p>

                <p
                  className="mb-4 leading-relaxed outer-font-color
                  app-body"
                >
                  Please watch the video that explains how you will use
                  NeedleEye to provide still images of your screen or
                  surroundings when prompted during the course your assessment.
                </p>

                <p
                  className="leading-relaxed outer-font-color
                 app-body"
                >
                  Please keep your device and NeedleEye App active throughout
                  your assessment.
                </p>
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div className="mt-auto w-full flex gap-3 justify-end pb-4 pr-4">
            <button
              onClick={goFullscreenReplay}
              className="btn-size flex bg-btnBgColor items-center px-6 py-1.5 text-white text-[16px]"
            >
              <img src={reloadImg} alt="reload" className="mr-2 w-4" />
              Play Again
            </button>

            <button
              onClick={handleProceed}
              className="btn-size flex items-center px-6 py-1.5 bg-btnBgColor text-white text-[16px]"
            >
              Proceed
              <img src={arrowImg} alt="arrow" className="ml-2" />
            </button>
          </div>

          <div className="w-full py-4 text-[10px] text-gray-600 text-center px-4">
            ©{" "}
            {new Date().getFullYear() > 2026
              ? `2026-${new Date().getFullYear()}`
              : "2026"}
            , Needles and Haystacks Technology Pvt Ltd.
          </div>
        </div>
      )}
    </div>
  );
};

export default Information;
